import { ExamCenterDetailsReadonlyFields } from '../../components';
import { useExamCenter } from '../../providers';

export default function ExamCenterReadonlyDetails() {
  const { examCenter } = useExamCenter();
  const {
    code,
    nameTH,
    nameEN,
    addressTH,
    phoneTH,
    addressEN,
    phoneEN,
    website,
    email,
    examResultRecipientEmail,
  } = examCenter;

  return (
    <ExamCenterDetailsReadonlyFields
      values={{
        code,
        nameTH,
        nameEN,
        addressTH: addressTH ?? '',
        phoneTH: phoneTH ?? '',
        addressEN: addressEN ?? '',
        phoneEN: phoneEN ?? '',
        website: website ?? '',
        email: email ?? '',
        examResultRecipientEmail: examResultRecipientEmail ?? '',
      }}
    />
  );
}
